export var LimitedCache =
/*#__PURE__*/
function () {
  function LimitedCache(capacity) {
    if (capacity === void 0) {
      capacity = 0;
    }

    this._cache = new Map();
    this._keysKeeper = [];
    this._capacity = Math.max(capacity, 0);
  }

  var _proto = LimitedCache.prototype;

  _proto.set = function set(key, value) {
    if (this._capacity === 0) {
      return;
    }

    var keyIndex = this._keysKeeper.indexOf(key);

    if (keyIndex === -1) {
      var length = this._keysKeeper.push(key);

      if (length > this._capacity) {
        var keyToDelete = this._keysKeeper.shift();

        this["delete"](keyToDelete);
      }
    }

    this._cache.set(key, value);
  };

  _proto["delete"] = function _delete(key) {
    this._cache["delete"](key);
  };

  _proto.clear = function clear() {
    this._cache.clear();

    this._keysKeeper.length = 0;
  };

  _proto.get = function get(key) {
    return this._cache.get(key);
  };

  _proto.has = function has(key) {
    return this._cache.has(key);
  };

  _proto.size = function size() {
    return this._keysKeeper.length;
  };

  return LimitedCache;
}();